// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"663":"ad58a7b6","746":"6e40076b"}[chunkId] + ".chunk.js";
};